module.exports = __webpack_public_path__ + "img/PlayMarket.2b03eb94.svg";